import {connect} from 'react-redux';

import {
    countNotifications,
    getNotificationsList,
    readNotifications,
} from 'reducers/siteNotification/siteNotificationActions';
import {createRole} from 'components/helpers/Role';
import NotificationCenter from './NotificationCenter';

const mapStateToProps = (state) => {
    const role = createRole(state.auth);
    return {
        ...state.siteNotifications,
        role,
    };
};

const mapDispatchToProps = {
    onCount: countNotifications,
    onGetList: getNotificationsList,
    onRead: readNotifications,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCenter);



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationCenterContainer.js